import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-island-container" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(['nav-island', 'ln-glass-elevated', { 'is-scrolled': _ctx.isScrolled }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(['island-item', { 'active': _ctx.activeSection === 'home' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('home')))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-home-outline" }, null, -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('nav.home')), 1)
      ], 2),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "island-separator" }, null, -1)),
      _createElementVNode("button", {
        class: _normalizeClass(['island-item', { 'active': _ctx.activeSection === 'infra' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('infra')))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mdi mdi-server-network" }, null, -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('nav.infrastructure')), 1)
      ], 2),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "island-separator" }, null, -1)),
      _createElementVNode("button", {
        class: _normalizeClass(['island-item', { 'active': _ctx.activeSection === 'projects' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('projects')))
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-rocket-launch-outline" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nav.projects')), 1)
      ], 2)
    ], 2)
  ]))
}